import { render, staticRenderFns } from "./SectionEachShopPost.vue?vue&type=template&id=1a76521a&scoped=true&lang=pug&"
import script from "./SectionEachShopPost.vue?vue&type=script&lang=js&"
export * from "./SectionEachShopPost.vue?vue&type=script&lang=js&"
import style0 from "./SectionEachShopPost.vue?vue&type=style&index=0&id=1a76521a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a76521a",
  null
  
)

export default component.exports